import { render, staticRenderFns } from "./storeData1.vue?vue&type=template&id=e271fcc6&scoped=true&"
import script from "./storeData1.vue?vue&type=script&lang=js&"
export * from "./storeData1.vue?vue&type=script&lang=js&"
import style0 from "./storeData1.vue?vue&type=style&index=0&id=e271fcc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271fcc6",
  null
  
)

export default component.exports